import { NextAppointment } from './NextAppointment';
export default NextAppointment;
